import Vue from 'vue';
import App from './App';
import router from './router';
// import 'lib-flexible';
import Vant from 'vant';
import 'vant/lib/index.css';
import VueTitle from 'vue-wechat-title';
import './utils/rem'
import wx from 'weixin-js-sdk'
Vue.config.productionTip = false
Vue.prototype.wx = wx
Vue.use(Vant)
Vue.use(VueTitle)
router.beforeEach((to, from, next) => {
    const agent = navigator.userAgent;
    const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isiOS && to.path !== location.pathname) {
        location.assign(to.fullPath)
    } else {
        next()
    }
});
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js